export const clientLogos = [
  { id: 1, name: "Akyapı", src: "/brand-logos/akyapi.png" },
  { id: 2, name: "Ekol", src: "/brand-logos/ekol.png" },
  { id: 3, name: "Eofis", src: "/brand-logos/eofis.png" },
  { id: 4, name: "Ethos", src: "/brand-logos/ethos.png" },
  { id: 5, name: "FK", src: "/brand-logos/fk.png" },
  { id: 6, name: "Roketsan", src: "/brand-logos/roketsan.png" },
  { id: 7, name: "Togg", src: "/brand-logos/togg.png" },
  { id: 8, name: "UNDP", src: "/brand-logos/undp.png" },
];
